import { render, staticRenderFns } from "./NavigationDrawerItem.vue?vue&type=template&id=947a4456&scoped=true"
import script from "./NavigationDrawerItem.vue?vue&type=script&lang=ts"
export * from "./NavigationDrawerItem.vue?vue&type=script&lang=ts"
import style0 from "./NavigationDrawerItem.vue?vue&type=style&index=0&id=947a4456&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "947a4456",
  null
  
)

export default component.exports